import React, { Component, Fragment } from 'react';
import AddressToNameService from './utils/AddressToNameService';
import Notifications from 'react-notify-toast';
import NotificationsHandler from './utils/NotificationsHandler';
import ReactTooltip from 'react-tooltip';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import HomePage from './components/HomePage/HomePage';
import CoinPage from './components/CoinsPage/CoinsPage';
import CouponPage from './components/CouponPage/CouponPage';
import OwnerDashboardPage from './components/OwnerDashboardPage/OwnerDashboardPage';
import SettingsPage from './components/SettingsPage/SettingsPage';
import AnalyticsPage from './components/AnalyticsPage/AnalyticsPage';
import AsyncCoinContractService, { NO_ACCOUNT_FOUND } from './utils/AsyncCoinContractService';
import { Provider } from 'react-redux';
import Storage from './storage/Storage';
import WalletInformationUpdaterService from './utils/WalletInformationUpdaterService';
import EventsUpdaterService from './utils/EventsUpdaterService';
import FullScreenLoadingAnimation from './components/Components/FullScreenLoadingAnimation';
import { NO_METAMASK_EXCEPTION } from './utils/Web3StatusService';
import NoMetamask from './components/NoMetamask';
import ErrorComponent from './components/ErrorComponent';
import EtherPage from './components/EtherPage/EtherPage';
import { ASYNC_NETWORK_ID } from './utils/Constants';
import WrongNetworkComponent from './components/WrongNetworkComponent';
import RequestHelper from './utils/RequestHelper';
import TutorialController from './components/Tutorial/TutorialController';
import Navigation from './components/Components/Navigation';
import NotFound from './components/NotFound';

const LOADING = 'LOADING';
const NO_METAMASK = 'NO_METAMASK';
const LOADED = 'LOADED';
const ERROR = 'ERROR';
const WRONG_NETWORK = 'WRONG_NETWORK';

class App extends Component {
  constructor (props) {
    super(props);

    this.state = {
      status: LOADING,
      errorMessage: null
    };

    window.addressToNameService = new AddressToNameService();
    window.notifications = new NotificationsHandler();
    window.requestHelper = new RequestHelper();

    // web3.js v1.0.0
    window.web3Service = null;
    // web3.js v0.22.*
    window.oldWeb3Service = null;
    window.oldWeb3Contract = null;
    window.contract = null;
    window.Storage = Storage;

    this.asyncCoinContractService = new AsyncCoinContractService();
    this.walletInformationUpdaterService = new WalletInformationUpdaterService();
    this.eventsUpdaterService = new EventsUpdaterService();
  }

  componentDidMount () {
    this.initContract();
  }

  initContract () {
    this.asyncCoinContractService
      .init()
      .then(() => this.initApp())
      .catch((err) => this.handleErrors(err));
  }

  handleErrors (err) {
    if (err === NO_METAMASK_EXCEPTION) {
      this.setState({status: NO_METAMASK});
      return;
    }

    if (err === NO_ACCOUNT_FOUND) {
      this.setState({
        status: NO_ACCOUNT_FOUND,
        errorMessage: 'We didn\'t find any accounts, please check your MetaMask configuration. Maybe you just didn\'t login to MetaMask.'
      });
      return;
    }

    this.setState({status: ERROR, errorMessage: err});
  }

  initApp () {
    this.checkNetwork();

    window.addressToNameService.init();
    this.walletInformationUpdaterService.init();
    this.eventsUpdaterService.init();
    this.setState({status: LOADED});

    this.setupCheckingForAccountChange();
  }

  setupCheckingForAccountChange () {
    setInterval(() => this.checkDidAccountChange(), 1000);
  }

  checkNetwork () {
    window.oldWeb3Service.version.getNetwork((err, netId) => {
      if (err) {
        console.error(err);
        return;
      }

      if (netId !== ASYNC_NETWORK_ID) {
        this.setState({status: WRONG_NETWORK});
      }
    });
  }

  checkDidAccountChange () {
    window.web3Service.eth.getAccounts((err, accounts) => {
      if (!accounts) {
        return;
      }

      // If account has changed, reload the page
      if (accounts[0] !== Storage.getState().account.currentAccount) {
        window.location.reload();
      }
    });
  }

  renderApp () {
    if (this.state.status === LOADED) {
      return (
        <Fragment>
          <Notifications options={{top: '50px'}}/>
          <ReactTooltip/>
          <TutorialController/>
          <div className="c-app">
            <Navigation/>
            <div className="c-container">
              <Switch>
                <Route exact path="/" component={HomePage}/>
                <Route path="/coin" component={CoinPage}/>
                <Route path="/coupons" component={CouponPage}/>
                <Route path="/owner-dashboard" component={OwnerDashboardPage}/>
                <Route path="/settings" component={SettingsPage}/>
                <Route path="/analytics" component={AnalyticsPage}/>
                <Route path="/ether" component={EtherPage}/>
                <Route component={NotFound}/>
              </Switch>
            </div>
          </div>
        </Fragment>
      );
    }

    if (this.state.status === NO_METAMASK) {
      return (<NoMetamask/>);
    }

    if (this.state.status === ERROR || this.state.status === NO_ACCOUNT_FOUND) {
      return (<ErrorComponent error={this.state.errorMessage}/>);
    }

    if (this.state.status === WRONG_NETWORK) {
      return (<WrongNetworkComponent/>);
    }

    return (<FullScreenLoadingAnimation/>);
  }

  render () {
    return (
      <Provider store={Storage}>
        <BrowserRouter>
          {this.renderApp()}
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js